var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { name: "fast-fade" } },
    [
      _vm.ready
        ? _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("service-pack")))]),
              _c(
                "w-card-content",
                { staticClass: "content" },
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(" " + _vm._s(_vm.validUntilText) + " "),
                      ]),
                      _vm.canBuy
                        ? [
                            _c(
                              "w-col",
                              { staticClass: "mt", attrs: { xs: "12" } },
                              [
                                _c("span", { staticClass: "product" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$ct("service-pack-for-a-year")
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c(
                                  "w-row",
                                  { staticClass: "mt" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$ct("labels.total")) +
                                        " "
                                    ),
                                    _c("w-spacer"),
                                    _vm._v(
                                      " €" +
                                        _vm._s(
                                          _vm._f("printHumanFloat")(
                                            _vm.priceExcVat
                                          )
                                        ) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.vat > 0
                              ? _c(
                                  "w-col",
                                  { attrs: { xs: "12" } },
                                  [
                                    _c(
                                      "w-row",
                                      {
                                        staticClass: "gray",
                                        attrs: { "no-margin": "" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$ct("vat-amount")) +
                                            " "
                                        ),
                                        _c("w-spacer"),
                                        _vm._v(
                                          " € " +
                                            _vm._s(
                                              _vm._f("printHumanFloat")(_vm.vat)
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "w-row",
                                      {
                                        staticClass: "mt total",
                                        attrs: { xs: "12" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$ct("price-with-vat")) +
                                            " "
                                        ),
                                        _c("w-spacer"),
                                        _vm._v(
                                          " € " +
                                            _vm._s(
                                              _vm._f("printHumanFloat")(
                                                _vm.price
                                              )
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.canBuy
                ? _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.disabled },
                          on: {
                            click: function ($event) {
                              return _vm.buy()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("pay-servicepack")) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }